<template lang="pug">
  div.position-relative
    b-card.border-0.mb-0
      b-form-group.mb-1(label-size="sm")
        template(#label)
          b-form-row.mt-2.mt-md-0.justify-content-between.align-content-center
            b-col(cols="auto").mb-2.mb-md-0
              p.mb-0.text-secondary Bloque ID:
                b-badge#font.ml-1 {{ $route.params.block_id }}
            b-col(cols="auto")
              p.mb-0.d-flex.align-content-center Es importante
                b-form-checkbox.ml-2.mb-0(switch, size="sm", v-model="block.is_important", @change="updateBlock")
        b-form-input(placeholder="Nombre de bloque", v-model="block.name", @input="updateDebounce", size="sm")
      b-form-group.mb-0(label="Guardar respuesta en variable", label-size="sm", label-cols="auto")
        k-select.mb-0(:options="user_attributes", placeholder="- No guardar -", v-model="block.user_attribute_id", @input="updateBlock")
      p.mt-2.text-secondary.text-sm Se guardará el título de un botón, título de respuesta rápida o el texto introducido por el usuario en esta variable.
      platforms-tabs(:active="platform", @click:active="platform = $event")
      b-overlay(:show="loading", variant="transparent", spinner-variant="primary")
        Block(v-bind="block", :disabled="false", :loading="loading")
      b-tabs(justified)
        b-tab.mt-3(title="Templates")
          b-form-group
            b-input-group(size="sm" )
              b-form-input(type="search", placeholder="Buscar template...", v-model="searchTemplate")
              b-input-group-append
                b-input-group-text
                  search-icon.icon-sm
          .mb-3(v-for="widget in templates_buttons", :key="widget.name")
            b-link.text-reset(v-b-toggle="widget.name", v-show="widget._templates.length")
              h5.mb-0 {{ widget.name }}
                chevron-down-icon.ml-1.icon-md
            b-collapse.mt-2(:id="widget.name", visible)
              b-form-row.justify-content-center
                b-col.mb-2(cols="4", lg="3", v-for="template in widget._templates", :key="template.type")
                  b-button.h-100(variant="outline-primary", block, size="sm", @click="createTemplate(template)", v-b-tooltip.hover, :title="template.info.description")
                    v-icon.icon-md.mb-2(:name="template.info.icon", v-if="template.info.icon.includes('brands/')")
                    component.icon-md.mb-1(:is="template.info.icon", v-else)
                    div {{ template.info.name }}
        b-tab.mt-3(title="Configuración")
          div(v-if="block.type !== 'logic'")
            b-form-group(label="Secuencia")
              b-input-group
                b-form-select(v-model="block.sequence_id", @change="updateSequence('associateSequence')")
                  option(:value="null", disabled) -- Selecciona secuencia --
                  option(v-for="sequence in sequences", :key="sequence.sequence_id", :value="sequence.sequence_id") {{sequence.name}}
                b-input-group-append
                  b-button(variant="soft-danger", @click="updateSequence('disassociateSequence')", :disabled="!block.sequence_id")
                    trash-2-icon.icon-sm
          b-card.bg-light.text-center.text-sm.mb-0.mt-4.text-danger
            alert-triangle-icon.icon-sm.mr-2
            b-link.text-danger(@click="$emit('destroy', block.block_id)") Eliminar bloque
    ScrollTop.position-absolute(element_id="block-container", right="60", bottom="0", v-if="ready" )
</template>

<script>
import Block from '@/components/templates/Block.vue'
import { createNamespacedHelpers, mapActions } from 'vuex'
import _debounce from 'lodash.debounce'
import PlatformsTabs from '@/components/PlatformsTabs.vue'
import ScrollTop from './ScrollTopBtn'
import Select from '@/components/Select.vue'
import { widgets } from '@/data/templates'

const accountController = createNamespacedHelpers('account')
const blockController = createNamespacedHelpers('block')
const organizationController = createNamespacedHelpers('organization')
const platformController = createNamespacedHelpers('platform')
const sequenceController = createNamespacedHelpers('sequence')

export default {
  data () {
    return {
      widgets: widgets.slice(),
      ready: false,
      loading: false,
      searchTemplate: '',
      platform: 'all',
      templateTypes: [
        { title: 'Normal', value: 'normal' },
        { title: 'Lógica', value: 'logic' },
        { title: 'Inicio proceso', value: 'init_process' },
        { title: 'Fin proceso', value: 'end_process' }
      ]
    }
  },
  computed: {
    ...accountController.mapGetters([
      'selectedLanguage',
      'selectedLocale',
      'selectedLanguageName'
    ]),
    ...accountController.mapState({
      user_attributes: state => state.user_attributes.map(a => {
        return {
          label: a.name,
          id: a.user_attribute_id
        }
      })
    }),
    ...organizationController.mapState({
      plugins: state => state.plugins.map(plugin => plugin.name)
    }),
    ...platformController.mapState({
      platforms: state => state.platforms
    }),
    ...sequenceController.mapState({
      sequences: state => state.sequences
    }),
    ...blockController.mapState({
      block: state => state.selected_block
    }),
    templates_buttons() {
      return widgets.filter(widget => {
        return widget.plugin ? this.plugins.includes(widget.plugin) : true
      }).map(element => {
        element._templates = element.templates.filter(template => {
          return (new RegExp(this.searchTemplate, 'i').test(template.info.name))
        }).sort((a, b) => {
          return a.info.name > b.info.name ? 1 : -1
        })
        return element
      })
    }
  },
  methods: {
    ...mapActions([
      'sequence/all',
      'block/get',
      'block/setBlock',
      'block/update',
      'block/destroy',
      'block/associateSequence',
      'block/disassociateSequence',
      'template/create'
    ]),
    getSequences () {
      const self = this

      this['sequence/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) return self.$message.warning(res.error)
        }
      })
    },
    getBlock () {
      const self = this
      this.loading = true

      this['block/get']({
        account_id: self.$route.params.account_id,
        block_id: self.$route.params.block_id,
        params: {
          platform: self.platform,
          language_id: self.selectedLanguage
        },
        callback: res => {
          self.loading = false

          if (res.error) return self.$message.warning(res.error)

          const { resource } = res

          self.$store.commit('block/setSelectedBlock', resource)
          self['block/setBlock'](resource)
          self.$nextTick(() => { self.ready = true })
        }
      })
    },
    updateBlock () {
      if (!this.ready || this.loading) return

      const self = this
      this.loading = true

      this['block/update']({
        account_id: self.$route.params.account_id,
        ...self.block,
        language_id: self.selectedLanguage,
        callback: res => {
          self.loading = false

          if (res.error) return this.$message.error(res.error)

          this.$message.success('Bloque actualizado')
        }
      })
    },
    updateDebounce: _debounce(function () {
      this.updateBlock()
    }, 4000, { leading: false, trailing: true }),
    updateSequence (action) {
      const self = this
      this.loading = true

      this[`block/${action}`]({
        account_id: self.$route.params.account_id,
        ...self.block,
        callback: res => {
          self.loading = false

          if (res.error) return this.$message.error(res.error)

          this.$message.success('Secuencia actualizada')

          if (action === 'disassociateSequence') self.block.sequence_id = null
        }
      })
    },
    createTemplate (template) {
      const self = this
      let templatePlatforms = []

      if (this.block.Templates.length) {
        templatePlatforms = this.block.Templates[this.block.Templates.length - 1].Platforms.map(platform => platform.platform_id)
      } else if (this.platform !== 'all') {
        const plat = this.platforms.find(platformToFind => platformToFind.name === this.platform)

        if (plat) templatePlatforms.push(plat.platform_id)
      }

      if (template.connectors) {
        for (const connector of template.connectors) {
          connector.next_block = this.block.block_id
          connector.flow_id = this.block.flow_id
        }
      }

      this['template/create']({
        language_id: self.selectedLanguage,
        block_id: self.block.block_id,
        number: self.block.Templates.length + 1,
        platforms: templatePlatforms,
        ...template,
        callback: async (res) => {
          if (res.error) {
            const res = await this.$bvModal.msgBoxConfirm('Ocurrió un error creando template. ¿Deseas intentarlo de nuevo?', {
              title: 'Error creando',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res) this.createTemplate.apply(this, arguments)
          } else {
            this.block.Templates.push(res.resource)
            this.$message.success('Template creado')
            this.$nextTick(() => { this.scrollToLastTemplate() })
          }
        }
      })
    },
    scrollToLastTemplate () {
      const element = $(`#templates_container_${this.block.block_id} > .template-message-row:last`)

      if (!element) return

      const position = $('#block-container').scrollTop() + element.offset().top - 30

      $('#block-container').animate({ scrollTop: position }, 1000)
    }
  },
  mounted () {
    this.getBlock()
  },
  watch: {
    platform () {
      this.getBlock()
    }
  },
  components: { PlatformsTabs, 'k-select': Select, Block, ScrollTop }
}
</script>

<style lang="scss" scoped>
#font {
  font-weight: 100;
  font-size: 13px;
  max-height: 20px;
}
</style>
